import { useMemo } from 'preact/hooks'

export const useSwatches = ({
    variantColors,
    variantImages,
    fallbackImage,
    swatchOptions1,
    swatchOptions2,
    productUrl
}) => {
    return useMemo(() => {
        if (!variantColors) {
            console.error('Did not receive swatch data for result')
            return []
        } else {
            let swatchList = new Set();

            variantColors.forEach(function (color, index) {
                let colorSwatches = Object.assign({}, swatchOptions1, swatchOptions2);
                let swatch = new Object();

                swatch.color = color.replaceAll('  ', ' ');
                swatch.fallback_img = fallbackImage;
                swatch.productUrl = productUrl

                variantImages.forEach(function (img, index) {
                  if (img.color == swatch.color) {
                       swatch.thumbnail = img.img;
                   }
                })

                if (colorSwatches[swatch.color]) {
                    swatch.swatch_options = colorSwatches[swatch.color]
                } else {
                    swatch.swatch_options = {}
                    console.error('No swatch options found for color value.')
                }
                swatchList.add(swatch);
            });

            return swatchList;
        }
    }, [
        variantColors,
        variantImages,
        fallbackImage,
        swatchOptions1,
        swatchOptions2,
        productUrl
    ])
}
